export default function Input({ label, ...props }) {
  return (
    <div className="flex flex-col gap-1">
      {label && <label className="text-sm font-medium">{label}</label>}
      <input
        {...props}
        className="border border-stone-300 bg-cream/70 rounded-lg p-2 focus:outline-accent focus:ring-1 focus:ring-accent"
      />
    </div>
  );
}
